// Mirrors backend/utils/objectCodes.js.
export const CODE_PAD_LENGTH = 3;

/**
 * buildCodePreview
 *
 * PROJ-001, or PROJ-2026-001 when the account includes the year. Used to keep
 * the preview column live while the form is being edited.
 */
export const buildCodePreview = (
  prefix,
  code,
  includeYear,
  year = new Date().getFullYear()
) => {
  const parts = [String(prefix ?? "").trim()];
  if (includeYear) parts.push(String(year));
  parts.push(String(Number(code) || 0).padStart(CODE_PAD_LENGTH, "0"));
  return parts.filter((part) => part !== "").join("-");
};
